module.exports = __webpack_public_path__ + "static/img/icons-categories-fill.41626931.svg";